export default __webpack_public_path__ + "static/media/LOGO_PURP.9b1ed055.png";